const firebaseConfig = {
    apiKey: "AIzaSyBhICFS-PPNhmB867igYrmWRSvCRS045y8",
    authDomain: "amader-sheba-pharmacy.firebaseapp.com",
    projectId: "amader-sheba-pharmacy",
    storageBucket: "amader-sheba-pharmacy.appspot.com",
    messagingSenderId: "269560293710",
    appId: "1:269560293710:web:45aa4cf5b457f0cd58161f"
  };
export default firebaseConfig;  